import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 48px;
  max-width: 860px;
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-radius: 16px;
`;

const listCss = css`
  margin-bottom: 32px;
  list-style: none;
`;

export const List = styled.ul<{ marginBottom?: number }>`
  ${listCss}
  margin-bottom: ${(props) => props.marginBottom}px;
`;

const listItemCss = css`
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-100']};
  line-height: 150%;

  &:before {
    content: '• ';
    color: ${(props) => props.theme.colors['neutral-100']};
    font-weight: bold;
    display: inline-block;
    width: 1em;
  }

  &:not(&:last-of-type) {
    margin-bottom: 2px;
  }
  p {
    display: inline;
  }
`;

export const ListItem = styled.li`
  ${listItemCss}
`;

const anchorListItemCss = css`
  color: ${(props) => props.theme.colors['primary-60']};

  &:before {
    color: ${(props) => props.theme.colors['primary-60']};
  }

  a {
    color: ${(props) => props.theme.colors['primary-60']};
    cursor: pointer;
  }
`;

export const AnchorListItem = styled(ListItem)`
  ${anchorListItemCss}
`;

export const Highlight = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.theme.colors['primary-60']};
  line-height: 150%;
`;

const regularTextCss = css`
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-100']};
  line-height: 150%;
  margin-bottom: 32px;
`;

export const RegularText = styled.p<{ marginBottom?: number }>`
  ${regularTextCss}
  margin-bottom: ${(props) => props.marginBottom ?? 32}px;

  a {
    color: ${(props) => props.theme.colors['primary-60']};
    cursor: pointer;
  }
`;

const titleCss = css`
  font-weight: 600;
  font-size: 26px;
  line-height: 115%;
  color: ${(props) => props.theme.colors['primary-60']};
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  ${titleCss}
`;

const subtitleCss = css`
  font-weight: 600;
  font-size: 18px;
  line-height: 115%;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 32px;
`;

export const Subtitle = styled.h2`
  ${subtitleCss}
`;

export const GenericContent = styled.div<{ withoutTopSpacing?: boolean }>`
  ${({ withoutTopSpacing }) =>
    !withoutTopSpacing &&
    `
    padding-top: 32px;
    border-top: 1px solid ${(props) => props.theme.colors['neutral-40']};
  `};
  margin-bottom: 32px;

  h1 {
    ${titleCss}
  }

  h1:not(:first-of-type) {
    border-top: 1px solid ${(props) => props.theme.colors['neutral-40']};
    padding-top: 32px;
  }

  h2 {
    ${subtitleCss}
  }

  p {
    ${regularTextCss}
  }

  ul {
    ${listCss}

    & ul {
      margin-left: 16px;
      margin-top: 4px;
      margin-bottom: 0;
    }

    & ul li {
      &:before {
        color: ${(props) => props.theme.colors['neutral-80']};
      }
    }
  }

  li {
    ${listItemCss}
  }

  li a {
    ${anchorListItemCss}
  }

  img {
    margin: auto;
  }
`;
